<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_1"></a>The Origin of the Logic<br/>of Symbolic Mathematics<a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?fd5e1c90